/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    SEARCH_SPLIT_LAYOUT
 * Date:         2025-12-30
 * Modified By:  Cursor
 *
 * Description:
 * Extracted layout measurement logic from useSearchState.ts.
 */

import { useState, useEffect, useRef } from "react";

export const useSearchLayout = (activeTab: string, itemsLength: number, filtersCollapsed: boolean) => {
  const inventoryListRef = useRef<HTMLDivElement>(null);
  const broadcastListRef = useRef<HTMLDivElement>(null);
  const [availableHeight, setAvailableHeight] = useState<number | null>(null);
  const [itemHeight, setItemHeight] = useState<number | null>(null);

  useEffect(() => {
    if (activeTab !== "inventory" && activeTab !== "broadcasts") {
      setAvailableHeight(null);
      setItemHeight(null);
      return;
    }

    const measureDimensions = () => {
      const ref = activeTab === "inventory" ? inventoryListRef : broadcastListRef;
      const selector = activeTab === "inventory" ? ".inv-row" : ".broadcast-item-card";
      if (ref.current) {
        const containerRect = ref.current.getBoundingClientRect();
        const firstItem = ref.current.querySelector(selector);
        if (firstItem) setItemHeight(firstItem.getBoundingClientRect().height);
        setAvailableHeight(Math.max(0, window.innerHeight - containerRect.top - 120));
      }
    };

    const timeoutId = setTimeout(measureDimensions, 100);
    window.addEventListener("resize", measureDimensions);
    return () => {
      window.removeEventListener("resize", measureDimensions);
      clearTimeout(timeoutId);
    };
  }, [activeTab, itemsLength, filtersCollapsed]);

  return { inventoryListRef, broadcastListRef, availableHeight, itemHeight };
};
